import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProfileStepHeader } from '../ProfileStepHeader';
import { FormActions } from './FormActions';

interface BaseFormLayoutProps {
  firstName: string;
  children: React.ReactNode;
  onBack?: () => void;
  onSubmit: (e: React.FormEvent) => void;
  isSubmitting: boolean;
  submitLabel?: string;
  submittingLabel?: string;
  withFormActions?: boolean;
}

export const BaseFormLayout: React.FC<BaseFormLayoutProps> = ({
  firstName,
  children,
  onBack,
  onSubmit,
  isSubmitting,
  submitLabel,
  submittingLabel,
  withFormActions = true,
}) => {
  const { t } = useTranslation('auth');

  return (
    <div className="flex flex-col md:flex-row md:min-h-[calc(100vh-4rem)] md:px-8 lg:px-[9.38rem]">
      <div className="w-full md:w-2/3 pt-28 pb-8 md:pr-8 flex flex-col">
        <ProfileStepHeader
          firstName={firstName}
          welcome={t('completeProfileStep.welcome')}
          completeSignup={t('completeSignup')}
          step={t('completeProfileStep.step')}
          completeInfo={t('completeProfileStep.completeInfo')}
          stepDesc={t('completeProfileStep.stepDesc')}
        >
          <div className="mt-8 text-[#3B5266] text-[0.9375rem] md:text-[0.875rem] leading-[1.25rem] md:leading-[1.1875rem]">
            <p className="mb-4">{t('completeProfileStep.info1')}</p>
            <p>{t('completeProfileStep.info2')}</p>
          </div>
        </ProfileStepHeader>
      </div>
      <div className="w-full md:w-1/3 flex flex-col justify-center py-8 md:py-16">
        <form className="w-full space-y-4" onSubmit={onSubmit} noValidate>
          {children}
          {withFormActions && (
            <FormActions
              onBack={onBack}
              onSubmit={onSubmit}
              isSubmitting={isSubmitting}
              submitLabel={submitLabel}
              submittingLabel={submittingLabel}
            />
          )}
        </form>
      </div>
    </div>
  );
};
